import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Button from '@material-ui/core/Button';
import AsyncSelect from 'react-select/async';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ManageLabelEntity } from '../ManageLabelEntity';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SelectAsyncCustom extends Component {

    constructor(props) {
        super(props);

        if (!props.url) {
            console.error("Must set a url for SelectAsyncCustom");
            return;
        }

        this.state = {
            url: props.url,
            isMulti: props.isMulti,
            name: props.name,
            title: props.title,
            clientOnChange: props.onChange,
            showManageButton: props.showManageBtn,
            dialogOpen: false,
            shouldReload: false
        };

        this.state.options = (search) => {
            var url = props.url;
            if (search) {
                url += '&search=' + search;
            }
            return fetch(url)
                .then(response => response.json())
                .catch(err => {
                    console.log('Can\'t load from url: ' + props.url);
                });
        }

        this.handleDialogOpen = this.handleDialogOpen.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleEntitiesChanged = this.handleEntitiesChanged.bind(this);
    }

    handleOnChange(options) {
        if (this.state.clientOnChange) {
            console.log(options)
            if (options != null) {
                if (this.state.isMulti) {
                    options = options.map(option => { option.id = option.id ? option.id : option.value; return option; })
                } else {
                    options.id = options.id ? options.id : options.value;
                }
            }
            this.state.clientOnChange(options);
        }
    }

    handleEntitiesChanged(newValue) {
        //this.props.value = newValue;
        this.setState({ shouldReload: !this.state.shouldReload });
    }

    handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    handleDialogClose = () => {
        this.setState({ dialogOpen: false, shouldReload: !this.state.shouldReload });
    };

    renderDialog() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={this.handleDialogClose} fullWidth={true} maxWidth="sm" aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    Manage {this.props.title}
                </DialogTitle>
                <DialogContent>
                    <ManageLabelEntity category={this.props.category} parent={this.props.parent} allowChildren={this.props.allowChildren} onChange={this.handleEntitiesChanged} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ dialogOpen: false })} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    render() {
        return (
            <div className="form-group">
                <label htmlFor={this.props.name}>{this.props.title} {this.props.showManageBtn && <span role="button" title="Manage Options" className="text-info ml-1" onClick={this.handleDialogOpen}><FontAwesomeIcon icon="edit" /></span>}</label>
                <AsyncSelect name={this.props.name} value={this.props.value} cacheOptions defaultOptions loadOptions={this.state.options} onChange={this.handleOnChange} isMulti={this.props.isMulti} closeMenuOnSelect={!this.props.isMulti} shouldReload={this.state.shouldReload} key={JSON.stringify(this.state.shouldReload)} getOptionValue={option => option['id']} isClearable />
                {this.props.showManageBtn &&
                    <div>                    
                        {ReactDOM.createPortal(this.renderDialog(), document.body)}                        
                    </div>
                }
            </div>
        );
    }
}